import type { ReactNode } from 'react';
import * as React from 'react';

import type { GutterItem } from '~/types';

import FallbackScreen from './FallbackScreen';

type Props = {
  children?: ReactNode;
  fallback?: ReactNode;
  selectedAlert?: GutterItem | null;
};

type State = {
  hasError: boolean;
};

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };

    this.reset = this.reset.bind(this);
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.selectedAlert === prevProps.selectedAlert) {
      return;
    }

    // The selected alert has changed, meaning we are viewing a new page.
    // Reset error state so that the user can see the new page.
    this.reset();
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    if (globalThis.dtrum) {
      globalThis.dtrum.reportError(error);
    }
  }

  reset() {
    this.setState({ hasError: false });
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ? (
        this.props.fallback
      ) : (
        <FallbackScreen resetError={this.reset} />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
